import { fieldDeleteApi } from "../../api/field/fieldDeleteApi"

type PayloadShape = Parameters<typeof fieldDeleteApi>[0]

export async function fieldDeleteService(payload: PayloadShape, token: string) {
	return await fieldDeleteApi(payload, token)
}
